import Reveal from '@/components/feature/Reveal';
import { topicTags } from '@/mocks/home';

const sizeMap: Record<string, string> = {
  lg: 'text-base md:text-lg px-5 py-3 font-bold',
  md: 'text-sm md:text-base px-4 py-2.5 font-semibold',
  sm: 'text-xs md:text-sm px-3.5 py-2 font-medium',
};

const toneMap: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-800 border-primary-200 hover:bg-primary-500 hover:text-background-50 hover:border-primary-500',
  accent: 'bg-accent-100 text-accent-900 border-accent-300 hover:bg-accent-500 hover:text-foreground-950 hover:border-accent-500',
  secondary: 'bg-secondary-100 text-secondary-900 border-secondary-200 hover:bg-secondary-600 hover:text-background-50 hover:border-secondary-600',
};

export default function TopicWall() {
  return (
    <section id="public-area" className="w-full bg-background-50 py-16 md:py-24">
      <div className="max-w-[1400px] mx-auto px-4 md:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-10 md:mb-14">
          <div className="max-w-2xl">
            <span className="inline-flex items-center gap-2 text-xs font-bold tracking-[0.2em] text-primary-600 uppercase">
              <i className="ri-hashtag" /> 话题墙
            </span>
            <h2 className="mt-3 font-heading text-3xl md:text-5xl font-black leading-tight text-foreground-950">
              今天大家都在蹲什么
            </h2>
            <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-600">
              公共区的话题墙按实时热度自动整理，从舞台返图到时间线复盘，想找同好一起扒细节，先在这里挑一个话题。
            </p>
          </div>
          <a
            href="#campus"
            className="shrink-0 inline-flex items-center gap-2 text-sm font-bold text-primary-600 hover:text-primary-700 whitespace-nowrap"
          >
            看完整话题 <i className="ri-arrow-right-line" />
          </a>
        </div>

        <Reveal>
          <div className="flex flex-wrap items-center gap-2.5 md:gap-3.5 rounded-lg border border-background-200 bg-background-100 p-5 md:p-8">
            <span className="inline-flex items-center gap-2 h-9 px-4 rounded-full bg-secondary-950 text-background-100 text-xs font-bold whitespace-nowrap">
              <i className="ri-time-line" /> 实时更新
            </span>
            {topicTags.map((tag) => (
              <a
                key={tag.label}
                href="#campus"
                className={`topic-tag inline-flex items-center rounded-full border whitespace-nowrap cursor-pointer ${sizeMap[tag.size]} ${toneMap[tag.tone]}`}
              >
                {tag.label}
              </a>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}